import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";
import { appendGaEventToAction } from "./googleAnalytics";

export const RECEIVE_APPCONFIG = "RECEIVE_APPCONFIG";
export const RECEIVE_APPCONFIG_SUCCESS = "RECEIVE_APPCONFIG_SUCCESS";
export const RECEIVE_APPCONFIG_FAIL = "RECEIVE_APPCONFIG_FAIL";
export const UPDATE_PROSPECT = "UPDATE_PROSPECT";
export const RESET_PROSPECT = "RESET_PROSPECT";
export const SET_CONFIG = "SET_CONFIG";
export const SET_PROSPECT = "SET_PROSPECT";
export const UPDATE_PROSPECT_ID = "UPDATE_PROSPECT_ID";
export const UPDATE_VALID_RO_CODE = "UPDATE_VALID_RO_CODE";
export const UPDATE_VIEW_ID = "UPDATE_VIEW_ID";
export const REMOVE_PROSPECT_ID = "REMOVE_PROSPECT_ID";
export const SAVE_SIGNATORY_MODEL = "SAVE_SIGNATORY_MODEL";
export const SAVE_ORGANIZATION_INFO_MODEL = "SAVE_ORGANIZATION_INFO_MODEL";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const RESET_APPLICANT_INFO = "RESET_APPLICANT_INFO";
export const LOAD_META_DATA = "LOAD_META_DATA";
export const SET_PROSPECT_LEAD = "SET_PROSPECT_LEAD";
export const SET_EXPIRED = "SET_EXPIRED";
export const SET_RO_CODE = "SET_RO_CODE";
export const INITIAL_CHECK = "INITIAL_CHECK";
export const KYC_INITIAL_EDIT_CHECK = "KYC_INITIAL_EDIT_CHECK";
export const UPDATE_RO_EMAIL = "UPDATE_RO_EMAIL";
export const UPDATE_ADDITIONAL_INFO = "UPDATE_ADDITIONAL_INFO";
export const SET_ACCORDION_STATUS = "SET_ACCORDION_STATUS";
export const SET_TAT = "SET_TAT";
export const UPDATE_PROSPECT_FROM_DECISION = "UPDATE_PROSPECT_FROM_DECISION";
export const SET_MOBILE_EMAIL_CHANGE = "SET_MOBILE_EMAIL_CHANGE";
export const POST_LOGIN_TOKEN = "POST_LOGIN_TOKEN";
export const POST_LOGIN_TOKEN_SUCCESS = "POST_LOGIN_TOKEN_SUCCESS";
export const POST_LOGIN_TOKEN_ERROR = "POST_LOGIN_TOKEN_ERROR";
export const SET_PREV_DEVICE_ID = "SET_PREV_DEVICE_ID";
export const SET_SHOW_COMPANY_DOC_UPLOAD = "SET_SHOW_COMPANY_DOC_UPLOAD";

export const loadMetaData = (meta = {}) => ({
  type: LOAD_META_DATA,
  payload: meta.freeField5 || ""
});

export const receiveAppConfig = () => ({
  type: RECEIVE_APPCONFIG
});

export const receiveAppConfigSuccess = payload => {
  return { type: RECEIVE_APPCONFIG_SUCCESS, payload };
};

export const receiveAppConfigFail = payload => {
  return { type: RECEIVE_APPCONFIG_FAIL, payload };
};

export const updateProspect = (payload, gaEvent = null) => {
  const action = { type: UPDATE_PROSPECT, payload };

  return appendGaEventToAction(action, gaEvent);
};

export const updateProspectFromDecision = (payload, gaEvent = null) => {
  const action = { type: UPDATE_PROSPECT_FROM_DECISION, payload };

  return appendGaEventToAction(action, gaEvent);
};

export const setConfig = payload => {
  return { type: SET_CONFIG, payload };
};

export const setInitialCheck = payload => {
  return { type: INITIAL_CHECK, payload };
};

export const setProspect = payload => {
  return { type: SET_PROSPECT, payload };
};

export const resetProspect = () => {
  return { type: RESET_PROSPECT };
};

export const updateProspectId = payload => {
  return { type: UPDATE_PROSPECT_ID, payload };
};

export const updateValidRoCode = payload => {
  return { type: UPDATE_VALID_RO_CODE, payload };
};

export const removeProspectId = () => {
  return { type: REMOVE_PROSPECT_ID };
};

export const updateViewId = (viewId, isSendToApi) => {
  return { type: UPDATE_VIEW_ID, payload: { viewId, isSendToApi } };
};

export const saveSignatoryModel = payload => {
  return { type: SAVE_SIGNATORY_MODEL, payload };
};

export const saveOrganizationInfoModel = payload => {
  return { type: SAVE_ORGANIZATION_INFO_MODEL, payload };
};

export const setAccessToken = (accessToken, refreshToken = "") => ({
  type: SET_ACCESS_TOKEN,
  payload: { accessToken, refreshToken }
});

export const resetApplicantInfo = () => ({ type: RESET_APPLICANT_INFO });

export const setProspectLead = payload => {
  return { type: SET_PROSPECT_LEAD, payload };
};

export const setRoCode = payload => {
  return { type: SET_RO_CODE, payload };
};

export const setExpired = expired => ({ type: SET_EXPIRED, payload: expired });

export const setKycInitialEditCheck = payload => {
  return { type: KYC_INITIAL_EDIT_CHECK, payload };
};

export const updateRoEmail = payload => {
  return { type: UPDATE_RO_EMAIL, payload };
};

export const updateAdditionalInfo = payload => {
  return { type: UPDATE_ADDITIONAL_INFO, payload };
};

export const setAccordionStatus = payload => {
  return { type: SET_ACCORDION_STATUS, payload };
};

export const setTat = payload => {
  return { type: SET_TAT, payload };
};

export const setMobileEmailChange = payload => {
  return { type: SET_MOBILE_EMAIL_CHANGE, payload };
};

export const postLoginTokenPromisify = payload => ({
  type: POST_LOGIN_TOKEN,
  [WAIT_FOR_ACTION]: POST_LOGIN_TOKEN_SUCCESS,
  [ERROR_ACTION]: POST_LOGIN_TOKEN_ERROR,
  payload
});

export const postLoginTokenSuccess = payload => {
  return { type: POST_LOGIN_TOKEN_SUCCESS, payload };
};

export const postLoginTokenError = payload => {
  return { type: POST_LOGIN_TOKEN_ERROR, payload };
};

export const setPrevDeviceId = (deviceId = "") => ({
  type: SET_PREV_DEVICE_ID,
  payload: { deviceId }
});

export const setShowCompanyDocsUploadInAccountInfo = payload => {
  return { type: SET_SHOW_COMPANY_DOC_UPLOAD, payload };
};
